import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-16'],
    fontFamily: fonts.din2014Regular,
  },
  header: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeHeading-4'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-1'],
    margin: 0,
  },

  info: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-16'],
    alignSelf: 'stretch',
  },
  icon: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  description: {
    color: colors.secondaryText,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
  action: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignSelf: 'stretch',
  },
});
